/**
 * @description: 收银交接明细报表
 * @author: hwx
 * @update: lyr
*/
<template>
    <div class="sjm-report">
        <div class="sjm-list">
            <p class="p-hint">注：1、交接款数据为营业额，现金、刷卡消费等为其具体支付类型。2、会员充值办卡不计入营业额，管理员充值等为会员充值具体类型</p>
            <div class="row row-margin">
                <label class="list-label-6">交接操作时间:</label>
                <div class="col-md-3 list-time">
                    <div ref="sjmTime">
                        <input type="text" class="form-control laydate-icon" v-model="sjmStartTime"> -
                        <input type="text" class="form-control laydate-icon" v-model="sjmEndTime">
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="sjm_shop" data-placeholder="请选择消费门店"></select>
                </div>
                <div class="col-md-1 ct-col jh-tit-sel">
                    <select class="form-control" ref="sjm_tit_sel">
                        <option value="admin_name">交接人</option>
                        <option value="admin_mobile">账号</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="sjm_con_val" :placeholder="sjm_con_phd">
                </div>
            </div>
            <div class="row row-margin">
                <el-button :type="tableType == 1 ? 'primary' : ''" @click="changeTableType(1)" size="small">交接班</el-button>
                <el-button :type="tableType == 2 ? 'primary' : ''" @click="changeTableType(2)" size="small">营业收入交接</el-button>
                <el-button type="primary" @click="getSjmList(1)" size="small">查询</el-button>
                <el-button @click="getSjmExportSet" size="small">导出</el-button>
                
            </div>
            <el-table 
                v-loading="loading" 
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)" 
                :data="sjm_list_table"
                :key="tableKey">
                <el-table-column v-for="(item, index) in sjm_column_tit" :fixed="item.fixed" :key="index"
                    :prop="item.prop" :label="item.label" :width="item.width">
                </el-table-column>
            </el-table>
            <el-pagination 
                background 
                layout="total, prev, pager, next, jumper" 
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="sjm_list_page" 
                :total="sjm_list_total" 
                @current-change="getSjmList"
            >
            </el-pagination>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="sjmExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='sjmExport_allcheck' @click='sjmExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li v-for="item in sjmExport_checkData" :key="item.key">
                            <input type="checkbox" v-model='sjmExport_checkModel' :value="item.key">
                            <label>{{item.name}}</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='sjmExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='sjmExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                sjmStartTime: "",
                sjmEndTime: "",
                sjm_field: "admin_name",
                sjm_con_phd: '请输入交接人姓名',
                sjm_con_val: "",
                sjmExport_allcheck: false,
                c_sjmExport_allcheck: false,
                sjmExport_checkModel: [],
                sjmExport_checkData: [],
                sjmExport_type: 1,
                sjmColumns: [],
				sjm_list_page: 1,
                sjm_list_total: 0,
                sjm_list_table: [],
                sjm_column_tit: [],
                tableType: 1, // 1交接班 2营业收入交接
                tableKey: Math.random(),
            }
        },
        watch: {
            sjmExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.sjmExport_checkModel.length >= this.sjmExport_checkData.length) {
                        this.sjmExport_allcheck = true;
                        this.c_sjmExport_allcheck = true;
                    } else {
                        this.sjmExport_allcheck = false;
                        this.c_sjmExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            const _this = this
            // 日期
            _this.sjmStartTime = moment().format('YYYY-MM-DD');
            _this.sjmEndTime = moment().add(1, 'day').format('YYYY-MM-DD');
            // 获取缓存
            let sjm_report_localStorage = JSON.parse(localStorage.getItem('sjm_table_type'));
            if(sjm_report_localStorage && sjm_report_localStorage.mobile == this.$store.state.usermobile) {
                this.tableType = sjm_report_localStorage.table_type;
            }
            _this.innitDate();
            _this.shopDatas = [];
            _this.innitInput();  // 门店
            // 下拉选项
            $(_this.$refs.sjm_tit_sel).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1,
                width: '100%'
            }).change(function() {
                _this.sjm_field = $(this).val();
                if(_this.sjm_field == 'admin_name') {
                    _this.sjm_con_phd = '请输入交接人姓名';
                } else if(_this.sjm_field == 'admin_mobile') {
                    _this.sjm_con_phd = '请输入账号';
                }
            });
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.sjmStartTime = moment().format('YYYY-MM-DD');
                            this.sjmEndTime = moment().add(1, 'day').format('YYYY-MM-DD');
                        }else {
                            this.sjmStartTime = moment().subtract(1, 'day').format('YYYY-MM-DD');
                            this.sjmEndTime = moment().format('YYYY-MM-DD');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                let _this = this;
                $(_this.$refs.sjmTime).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                    dateLimit: {
                        days: 31
                    },
                }, function(start, end, label) {
                    _this.sjmStartTime = start.format('YYYY-MM-DD');
                    _this.sjmEndTime = end.format('YYYY-MM-DD');
                });
            },
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            _this.shopDatas.shift();
                            $(_this.$refs.sjm_shop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            }).on("select2:select", function(e) {
                                _this.setShopDefaultTime(e.params.data.id)
                            });
                            _this.setShopDefaultTime(data.response.result[1].id)
                            _this.getSjmList(1);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },



            getSjmList(page) {
				const _this = this;

                _this.loading = true;
                _this.sjm_list_page = page
                let url = 'FinanceReport2/getShiftTurnoverList'
                if(_this.tableType == 2) {
                    url = 'FinanceReport2/getShopShiftTurnoverList'
                }
				Vue.axios.post(url, {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_date": _this.sjmStartTime,
                            "end_date": _this.sjmEndTime,
                            "shop_id": $(_this.$refs.sjm_shop).val(),
                            "key_word": _this.sjm_field,
                            "search_word": _this.sjm_con_val
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.sjm_list_total = Number(res.data.response.result.count);
                            _this.sjm_column_tit = [];
                            _this.sjmExport_checkData = [];
                            for(let [key, value] of Object.entries(res.data.response.result.column_arr)) {
                                if(key == 'transfer_time' || key == 'start_time' || key == 'end_time' || key == 'free_amount' || key == 'recharge_free_amount' || key.indexOf('custom_') > -1) {
                                    _this.sjm_column_tit.push({ prop: key, label: value, width: '110' });
                                } else if(key == 'vip_turnover') {
                                    _this.sjm_column_tit.push({ prop: key, label: value, width: '120' });
                                } else {
                                    _this.sjm_column_tit.push({ prop: key, label: value, width: 'auto' });
                                }
                                _this.sjmExport_checkData.push({ key: key, name: value });
                            }
						}
						_this.sjm_list_table = res.data.response.result.data;
						_this.loading = false;
                        _this.tableKey = Math.random();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

            changeTableType(type) {
                this.tableType = type;
                this.getSjmList(1);
                // 缓存本地
                let sjm_report_localStorage = {
                    "table_type": type,
                    "mobile": this.$store.state.usermobile
                }
                localStorage.setItem('sjm_table_type', JSON.stringify(sjm_report_localStorage));
            },

            // 获取导出设置
            getSjmExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": _this.tableType == 1 ? 'FinanceReport2/shiftTurnoverExport' : 'FinanceReport2/shopShiftTurnoverExport'
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: {
                        json: datas2
                    },
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.sjmExport_checkModel = data.response.result.export_fields;
                                _this.sjmExport_type = data.response.result.export_type;
                            } else {
                                _this.sjmExport_checkModel = [];
                                _this.sjmExport_checkData.forEach(function(item) {
                                    _this.sjmExport_checkModel.push(item.key);
                                });
                                _this.sjmExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.sjmExport_alert)
                }, function() {
                    _this.exportSjmList();
                });
            },
            // 导出字段全选
            sjmExportCheckedAll: function() {
                let _this = this;
                _this.sjmExport_allcheck = _this.c_sjmExport_allcheck;
                if(!_this.sjmExport_allcheck) { // 实现全选
                    _this.sjmExport_checkModel = [];
                    _this.sjmExport_checkData.forEach(function(item) {
                        _this.sjmExport_checkModel.push(item.key);
                    });
                } else { // 实现反选
                    _this.sjmExport_checkModel = [];
                }
            },
            // 导出账单汇总列表
            exportSjmList: function() {
                let _this = this;

                if(_this.sjmExport_checkModel.length == '0') {
                    layer.msg('导出字段不能为空');
                    return false;
                }
                let export_fields = JSON.stringify(_this.sjmExport_checkModel);
                let url = _this.tableType == 1 ? 'FinanceReport2/shiftTurnoverExport' : 'FinanceReport2/shopShiftTurnoverExport'
                window.location.href = Vue.ctUrl + url + "?" +
                    "&start_date=" + _this.sjmStartTime +
                    "&end_date=" + _this.sjmEndTime +
                    "&shop_id=" + $(_this.$refs.sjm_shop).val() +
                    "&key_word=" + _this.sjm_field +
                    "&search_word=" + _this.sjm_con_val +
                    "&export_fields=" + export_fields +
                    "&export_type=" + _this.sjmExport_type;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    
</style>